import React from "react";
import styled from "@emotion/styled";
import SellReceiptImage from "./SellReceiptImage";
import { useDispatch } from "react-redux";
import { defaultAction } from "@actions/defaultAction";
import { SHOW_SELL_RECEIPT_MODAL } from "@constants/actionTypes";

const Main = styled.div`
  text-align: left;
  margin: 0 auto;
`;

const Step = styled.div`
  padding-top: 45px;

  @media (max-width: 350px) {
    padding-top: 38px;
  }
`;

const NextStep = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 2;
  color: #1f2021;
  margin-bottom: 25px;
`;

const LineGrid = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-gap: 20px;
  align-items: center;
  padding-top: ${props => props.paddingTop};

  @media (max-width: 350px) {
    display: block;
    padding-top: ${props => props.paddingMobileTop};
  }
`;

const TextHeader = styled.div`
  font-size: 16px;
  line-height: 1.88;
  color: #777984;
`;

const TextHeaderBoldSpan = styled.span`
  font-weight: 500;
  color: #1f2021;
`;

const TextHeaderYellowSpan = styled.span`
  color: #ff9c1b;
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
`;

const MailGrid = styled.div`
  grid-column: 2/3;
  font-size: 16px;
  line-height: 1.88;
  color: #777984;
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 60px;
  width: fit-content;

  @media (max-width: 575px) {
    font-size: 15px;
    grid-gap: 50px;
  }
  @media (max-width: 500px) {
    grid-template-columns: auto;
    grid-gap: 35px;
  }
  @media (max-width: 350px) {
    margin-top: 24px;
    grid-gap: 26px;
  }
`;

const MailHeader = styled.div`
  font-weight: 500;
  color: #1f2021;
`;

const Instructions = ({
  type,
  checkoutOrdersSellID,
  sellOrderToRender,
  receiptPopup
}) => {
  const dispatch = useDispatch();

  let header;
  if (receiptPopup) {
    header =
      sellOrderToRender.cards.length > 1
        ? "Please note that all cards in this order must be mailed in."
        : "Please note that this card must be mailed in.";
  } else {
    header =
      sellOrderToRender.cards.length > 1
        ? "Mail in the cards"
        : "Mail in the card";
  }
  return (
    <Main>
      {type !== "ecode" && (
        <Step>
          {!receiptPopup && <NextStep>Next steps:</NextStep>}
          <LineGrid className="receipt-print-line-grid">
            <SellReceiptImage
              src={
                "https://cdn.cardcash.com/website/ui/elements/mail-green2.svg"
              }
              alt="receipt"
            />
            <div>
              <TextHeader>
                <TextHeaderBoldSpan>{header}</TextHeaderBoldSpan>
                {receiptPopup ? (
                  <span>&nbsp;Send the cards to:&nbsp;</span>
                ) : (
                  <span>&nbsp;via USPS or FedEx/UPS&nbsp;</span>
                )}

                {!receiptPopup && (
                  <TextHeaderYellowSpan
                    onClick={() =>
                      dispatch(
                        defaultAction(
                          SHOW_SELL_RECEIPT_MODAL,
                          checkoutOrdersSellID
                        )
                      )
                    }
                  >
                    along with a copy of the receipt page.
                  </TextHeaderYellowSpan>
                )}
              </TextHeader>
            </div>
            <MailGrid className="receipt-print-mail-grid">
              <div>
                <MailHeader>Via USPS</MailHeader>
                <div>
                  ABC Processing Center
                  <br /> P.O. Box 2045
                  <br /> Lakewood, NJ 08701
                </div>
              </div>
              <div>
                <MailHeader>Via FedEx/UPS</MailHeader>
                <div>
                  ABC Processing Center
                  <br /> 990 Cedar Bridge Ave
                  <br /> STE B7, RM 365
                  <br />
                  Brick, NJ 08723
                </div>
              </div>
            </MailGrid>
          </LineGrid>
        </Step>
      )}
      <Step>
        <NextStep>You're done! Here is what will happen next:</NextStep>
        <LineGrid className="receipt-print-line-grid">
          <SellReceiptImage
            src={"https://cdn.cardcash.com/website/ui/elements/zoom-green2.svg"}
            alt="icon"
          />
          {type !== "ecode" ? (
            <TextHeader>
              Once we receive the cards,
              <TextHeaderBoldSpan>
                &nbsp;we’ll verify the cards balance
              </TextHeaderBoldSpan>
            </TextHeader>
          ) : (
            <TextHeader>
              The card's balance will be
              <TextHeaderBoldSpan>&nbsp;verified</TextHeaderBoldSpan>
            </TextHeader>
          )}
        </LineGrid>
        <LineGrid
          paddingTop={"40px"}
          paddingMobileTop={"25px"}
          className="receipt-print-line-grid receipt-print-line-grid-padding"
        >
          <SellReceiptImage
            src={"https://cdn.cardcash.com/website/ui/sell/cash-bills.svg"}
            alt="icon"
          />
          <TextHeader>
            <TextHeaderBoldSpan>
              Payment will be initiated&nbsp;
            </TextHeaderBoldSpan>
            within two business days
          </TextHeader>
        </LineGrid>
      </Step>
    </Main>
  );
};

export default Instructions;
